<script>
	// The params prop contains values matched from the URL
	export let params = {} 

	import { replace, push } from 'svelte-spa-router';
	import { createEventDispatcher, onMount } from 'svelte';
	import TBoxInterno from '../templates/TBoxInterno.svelte';
	import BarraOperacoesRegistro from '../../componentes/BarraOperacoesRegistro.svelte';
	import { sTituloPaginaAtual } from '../../stores';
	import {
		API,
		TipoEvento,
		StatusHttp,
		cabecalhoPadraoRequisicao,
		dadosUsuarioLS,
		TextoFeedback,
		ativarLinksEmTexto,
		rolarPagina,
		TipoPerfil,
		gerarNrEntre,
		revstr, removerObjeto
	} from '../../utils';

	const dispatch = createEventDispatcher();
	let apresentacao = {};
	let dadosUsuario;
	let opcoesOperacoes = [];
	let opcoesOperacoesTopo = [];
	let opcoesOperacoesRodape = [];
	let anexos = [];
	let perfilUsuarioToken = "";
	let distribuicoes = [];
	let avaliacoes = [];
	let incluiAlunosEAD;
	let discenteLogadoApresentador = false;
	let arrayAuxDiscentesApresentacoes = [];

	onMount(async () => {
		dispatch('routeEvent', { tipo: TipoEvento.FECHAR_MODAL });

		$sTituloPaginaAtual = `Visualização de Apresentação (Projeto: ${params.codigoProjeto})`;
		
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando apresentação ...',
		});
		
		dadosUsuario = dadosUsuarioLS();
		perfilUsuarioToken = dadosUsuario.perfil;

		const resposta = await fetch(API(`apresentacoes/${params.id}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			console.log(erros);
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("#/painel");
		});
		
		const { dados, status } = await resposta.json();

		if (status == StatusHttp.OK) {
			apresentacao = dados;
			anexos = apresentacao.anexos;
			avaliacoes = apresentacao.avaliacoes;
			distribuicoes = apresentacao.distribuicoes;

			let verificacaoAlunosEAD = apresentacao?.inclui_alunos_ead;

			if (verificacaoAlunosEAD === 0)
				incluiAlunosEAD = "NÃO";
			else if (verificacaoAlunosEAD === 1)
				incluiAlunosEAD = "SIM";
			else
				incluiAlunosEAD = "Informação não cadastrada";
				
			opcoesOperacoes = [{
				titulo: 'Painel',
				callback: () => push('#/painel')
			}];

			// verifica em cada anexo se a informação do apresentador é igual aos dados do login do discente atualmente logado
			anexos.forEach(({ valor }) => {
				arrayAuxDiscentesApresentacoes.push(comparaUsuarioApresentador(dadosUsuario, valor));
			});

			switch (perfilUsuarioToken) {
				case TipoPerfil.COORDENADOR:
					opcoesOperacoes.push({
						titulo: 'Voltar ao projeto',
						cor: 'is-primary',
						callback: () => push(`#/projeto/visualizar/${params.codigoProjeto}`)
					}, {
						titulo: 'Certificado Part. (PDF)',
						cor: 'is-info',
						callback: () => window.open(API(`certificado-participacao/download/${apresentacao?.ano}/${gerarNrEntre(11111, 99999)}-${revstr(params.codigoProjeto)}-${revstr(dadosUsuario.cpf)}-${window.btoa(revstr(params.codigoProjeto))}`), '_blank')
					}, {
						titulo: 'Remover',
						cor: 'is-danger',
						callback: () => removerApresentacao(params.id)
					});
				break;

				case TipoPerfil.DISCENTE:
					opcoesOperacoes.push({
						titulo: 'Voltar ao projeto',
						cor: 'is-primary',
						callback: () => push(`#/projeto/visualizar/${params.codigoProjeto}`)
					});

					// só exibir opção de logar nos casos de acesso discente, se o discente logado foi o apresentador de fato
					if (arrayAuxDiscentesApresentacoes.includes(true)) {
						opcoesOperacoes.push({
							titulo: 'Certificado Part. (PDF)',
							cor: 'is-info',
							callback: () => window.open(API(`certificado-participacao/download/${apresentacao?.ano}/${gerarNrEntre(11111, 99999)}-${revstr(params.codigoProjeto)}-${revstr(dadosUsuario.cpf)}-${window.btoa(revstr(params.codigoProjeto))}`), '_blank')
						});
					}
				break;

				case TipoPerfil.CETREINA:
					opcoesOperacoes.push({
						titulo: 'Ver projeto',
						cor: 'is-primary',
						callback: () => push(`#/projeto/visualizar/${params.codigoProjeto}`)
					}, {
						titulo: 'Remover',
						cor: 'is-danger',
						callback: () => removerApresentacao(params.id)
					});
				break
			}
		} else {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			replace('#/apresentacao-inexistente');

			return;
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		opcoesOperacoesTopo = [ ... opcoesOperacoes];
		opcoesOperacoesRodape = [ ... opcoesOperacoes];

		opcoesOperacoesTopo.push({
			titulo: 'Rolar para baixo',
			cor: 'is-black is-outlined', 
			callback: () => rolarPagina(document.body.scrollHeight)
		});

		opcoesOperacoesRodape.push({
			titulo: 'Rolar para cima',
			cor: 'is-black is-outlined',
			callback: () => rolarPagina(0)
		});
	});

	const removerApresentacao = async (idApresentacao) => removerObjeto(idApresentacao, dispatch, push, '#/painel/projetos', 'apresentacoes', 'Deseja realmente remover esta apresentação? \n\nA apresentação só poderá ser recupera por solicitação via e-mail, com justificativa.');
	
	const comparaUsuarioApresentador = (usuarioLS, valorAnexo) => {
  		let nome = usuarioLS.nome;
  		let cpf = usuarioLS.cpf.toString();

		// Aplica a máscara no CPF
		cpf = cpf.replace(/(\d{3})(\d{6})(\d{2})$/, '$1######$3');
		return `${nome} (${cpf})` === valorAnexo;
	}
</script>

<TBoxInterno
	titulo="Apresentação do projeto: {apresentacao?.projeto?.titulo}" 
	subtitulo="Inscrição { apresentacao?.id_zerofill }/{ apresentacao?.ano }"
	largura="12" 
	deslocamento="0">

	<br>
	
	<BarraOperacoesRegistro opcoes={ opcoesOperacoesTopo } />

	<p>Código do Projeto: <strong>{ apresentacao?.projeto?.codigo }</strong></p>
	<p>Inclui estudantes dos cursos de graduação EAD: <strong>{ incluiAlunosEAD }</strong></p>

	<hr>

	<p class="is-size-4 mb-4">Resumo</p>
	<div class="content">
		<p class="is-size-5 permitir-selecao">{ apresentacao?.resumo }</p>
	</div>

	<p class="has-text-centered">
		<span class="tag" title="Data de criação do projeto (adicionado no sistema)">Data inscrição: {apresentacao?.data_criacao}</span>
	</p>

	<br>

	{#if anexos?.length > 0}
	<p class="is-size-4 mb-4">Anexos</p>

	<div style="overflow-x: auto !important">
		<table class="table is-fullwidth is-hoverable permitir-selecao">
			<thead>
				<tr>
					<th>Tipo</th>
					<th>Conteúdo</th>
				</tr>
			</thead>
			<tbody>
				{#each anexos as anexo}
				<tr>
					<td>{ anexo.tipo }</td>
					{#if anexo.valor.trim().startsWith('http')}
					<td><a href="{anexo.valor.trim()}" target="_blank">{anexo.valor.trim()}</a></td>
					{:else}
					<td>{ anexo.valor.trim() }</td>
					{/if}
				</tr>
				{/each}
			</tbody>
		</table>
	</div>
	{/if}

	{#if perfilUsuarioToken == TipoPerfil.CETREINA}

	<p class="is-size-4 mb-4">Distribuição</p>

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>#</th>
				<th>Avaliador(a)</th>
				<th>Data distr.</th>
				<th>Detalhes</th>
				<th class="has-text-right">Data aceite</th>
			</tr>
		</thead>
		<tbody>
			{#each distribuicoes as distribuicao, i}
			<tr>
				<th>{ ++i }</th> 
				<td><a href="#/usuario/visualizar/{ distribuicao.avaliador.cpf }">{ distribuicao.avaliador.nome }</a></td>
				<td>{ distribuicao.data_distribuicao }</td>
				<td><a href="#/distribuicao/desfazer/confirmacao/{ distribuicao.id }" class="button  is-small is-dark is-outlined">Desfazer</a></td>
				<td class="has-text-right">{ distribuicao.data_aceite }</td>
			</tr>
			{:else}
				<tr>
					<td colspan="6">Apresentação não distribuída.</td>
				</tr>
			{/each}
		</tbody>
	</table>
	{/if}

	{#if avaliacoes?.length > 0}
	<br>

	{#if perfilUsuarioToken == TipoPerfil.CETREINA}
	<p class="is-size-4 mb-4">Avaliações</p>

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>#</th>
				<th>Avaliador(a)</th>
				<th>Pontuação</th>
				<th>Última atualização</th>
				<th>Detalhes</th>
				<th class="has-text-right">Status</th>
			</tr>
		</thead>
		<tbody>
			{#each avaliacoes as avaliacao, i}
			<tr>
				<th>{ ++i }</th> 
				<td><a href="#/usuario/visualizar/{ avaliacao.avaliador.cpf }">{ avaliacao.avaliador.nome }</a></td>
				<td>{ avaliacao.pontuacao }</td>
				<td>{ avaliacao.data_ultima_atualizacao }</td>
				{#if perfilUsuarioToken == TipoPerfil.CETREINA}
				<td><a href="#/avaliacao/visualizar/{avaliacao.id}" class="button  is-small is-dark is-outlined">Abrir</a></td>
				{:else}
				<td>...</td>
				{/if}
				<td class="has-text-right">{ avaliacao.finalizada == true ? 'Finalizada' : 'Pendente' }</td>
			</tr>
			{:else}
			<tr>
				<td colspan="6">Nenhuma avaliação ainda.</td>
			</tr>
			{/each}
		</tbody>
	</table>
	
	{:else}
	
	<h1 class="title is-2 mt-6 mb-6 has-text-centered">Histórico de Avaliações</h1>

	<table class="table is-fullwidth is-bordered">
		<thead>
			<tr>
				<th>Ano</th>
				<th>Status da avaliação</th>
				<th>Pontuação</th>
				<th>Ações</th>
			</tr>
		</thead>
		<tbody>
			{#each avaliacoes as avaliacao}
			<tr>
				<td>{ avaliacao.ano_ultima_atualizacao }</td>
				<td class="has-text-right">{ avaliacao.finalizada == true ? 'Finalizada' : 'Pendente' }</td>
				<td>{ avaliacao.pontuacao }</td>
				<td class="has-text-right"><a href="#/avaliacao/visualizar/anonimizada/{avaliacao.id}" class="button is-fullwidth is-small is-primary">Abrir</a></td>
			</tr>
			{:else}
			<tr>
				<td colspan="6">Nenhuma avaliação ainda.</td>
			</tr>
			{/each}
		</tbody>
	</table>
	{/if}
	{/if}

	<div class="my-4 has-text-centered">
		<small>Dica: Para copiar um texto selecionado, utilize os atalhos do teclado (Windows/Linux: Ctrl + C) - MacOS (Cmd + C). <a href="https://support.google.com/docs/answer/161768?hl=pt-BR&co=GENIE.Platform%3DDesktop#:~:text=Copie%20e%20cole%20usando%20atalhos,e%20%E2%8C%98%20%2B%20v%20para%20colar." target="_blank">Veja mais detalhes clicando aqui</a>.</small>
	</div>

	<hr>

	<BarraOperacoesRegistro opcoes={ opcoesOperacoesRodape } />
</TBoxInterno>